export { default } from './BlocAreaUsuaris';
